/*
 * Phosis — open the cart drawer on every add-to-cart, site-wide.
 *
 * Several custom sections (homepage product grid, PDP main + sticky bars) use
 * plain `<form action="/cart/add">` posts that would otherwise reload the page
 * to /cart. This delegates on the document so any such form instead adds via
 * AJAX and opens the cart drawer — on all pages, including sections rendered
 * after load.
 *
 * It deliberately skips:
 *   - forms inside a Dawn <product-form> (product-form.js already opens the drawer)
 *   - the cart page itself (reloads so line items/totals refresh)
 *   - forms marked [data-no-drawer] (explicit opt-out, e.g. Buy Now flows)
 */
(function () {
  function addUrl() {
    return (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (form.closest('product-form')) return;     // Dawn handles + opens drawer
    if (form.hasAttribute('data-no-drawer')) return;

    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;                       // notification/page mode: leave native behaviour

    event.preventDefault();

    var submitBtn = form.querySelector('[name="add"], [type="submit"]');
    if (submitBtn && submitBtn.getAttribute('aria-disabled') === 'true') return;

    var sections = cartDrawer.getSectionsToRender
      ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-drawer', 'cart-icon-bubble'];

    var formData = new FormData(form);
    formData.append('sections', sections.join(','));
    formData.append('sections_url', window.location.pathname);

    if (submitBtn) { submitBtn.setAttribute('aria-disabled', 'true'); submitBtn.classList.add('loading'); }

    fetch(addUrl(), {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data.status) {
          // Sold out / error — fall back to a native submit so Shopify surfaces it.
          form.submit();
          return;
        }
        // On the full cart page, reload so line items + totals refresh.
        if (document.getElementById('main-cart-items')) { window.location.reload(); return; }

        if (typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(data);          // re-renders #CartDrawer and opens it
        } else {
          window.location = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'phosis-cart-drawer' });
        }
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        if (submitBtn) { submitBtn.removeAttribute('aria-disabled'); submitBtn.classList.remove('loading'); }
      });
  });
})();
